import React from 'react';

import ButtonTertiary from '../ButtonTertiary';
import Wysiwyg from '../Wysiwyg';
import Wrapper from '../../ui/Wrappers';
import { getSrcset } from '../../ui/helpers';
import { Image, Module } from './styles';

interface IProps {
  imageUrl: any;
  text: string;
  translates: any;
  imageAlt?: string;
  backLink?: string;
}

const News = ({ imageUrl, imageAlt, text, translates: t, backLink }: IProps) => {
  return (
    <Module>
      {imageUrl && (
        <Image
          src={imageUrl.original?.href}
          aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
          srcSet={getSrcset(imageUrl)}
          webp={getSrcset(imageUrl, true)}
          alt={imageAlt || ''}
          className="image"
        />
      )}
      {text && (
        <Wrapper size="reader">
          <Wysiwyg className="text" text={text} />
        </Wrapper>
      )}
      {backLink && (<Wrapper size="reader" style={{ textAlign: 'center', paddingTop: '32px' }}>
        <ButtonTertiary className={'backTertiary'} to={backLink} label={t.news.showAll} />
      </Wrapper>)}
    </Module>
  );
};

export default News;
